module.exports = __webpack_public_path__ + "img/cyberpunk-2077.6da61075.png";